class ValidationService {
  constructor() {
    this.required = value => value || typeof value === 'number' ? undefined : 'Required';

    this.minLength = (minimumLength, customMessage = '') => value => {
      const message = customMessage !== '' ? customMessage : `Must be ${minimumLength} characters or more.`;
      return value && value.length < minimumLength ? message : undefined;
    };

    this.exactLength = (exactLengthNums, customMessage = '') => value => {
      if (!value) {
        return undefined;
      }

      exactLengthNums = Array.isArray(exactLengthNums) ? exactLengthNums : Array.of(exactLengthNums);
      const exactLength = value.length && exactLengthNums.some(length => value.length === length);
      return !exactLength ? customMessage : undefined;
    };

    this.passwordsMatch = (value, allValues) => {
      return allValues.password !== allValues.confirmPassword ? 'Passwords must match' : undefined;
    };

    this.isInteger = value => {
      if (!value) {
        return undefined;
      }

      return value.match(/^\d+$/) ? undefined : 'Please enter a whole number';
    };

    this.isIntegerGreaterThenZero = value => {
      if (!value) {
        return undefined;
      }

      return value.match(/^[1-9][0-9]*$/) ? undefined : 'Please enter a number greater than 0';
    };

    this.percentageRange = value => {
      if (!value) {
        return undefined;
      }

      const intValueInRange = value.match(/^\d+$/) && value > 0 && value <= 100;
      const floatValueInRange = value.match(/^\d+(\.\d{1,2})?$/) && value > 0 && value <= 100.0;

      return intValueInRange || floatValueInRange ? undefined : 'Please enter a number between 0 and 100';
    };

    this.customTaxIdBrazilValidation = value => {
      return value.match(/^\d{14}$/) ? undefined : 'Must be a whole number = 14 digits.';
    };
  }

}

export default new ValidationService();